import { z } from 'zod';

export const createApiKeyFormSchema = z.object({
  label: z.string().min(1, 'Label is required').max(100, 'Label must be 100 characters or fewer'),
});

export type CreateApiKeyFormValues = z.infer<typeof createApiKeyFormSchema>;
